import React, { useState } from 'react';
import Logo from './Logo.png';
import Apple from './Apple.png';
import axios from 'axios';

const Home = () => {
  const [phone, setPhone] = useState('');
  const [request, setRequest] = useState({
    success: null,
    loading: null,
  });

  const onChange = (e) => {
    setPhone(e.target.value);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setRequest({ ...request, loading: true });

    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const body = JSON.stringify({ phone });

    try {
      const res = await axios.post('/send', body, config);
      console.log(res.data.data.messages[0].status);

      setRequest({ ...request, loading: false });
    } catch (err) {
      console.log(err.response);
      setRequest({ ...request, loading: false });
    }
  };

  return (
    <div className="home">
      <div className="logo">
        <img src={Logo} alt="..." />
      </div>
      <div className="text">
        <p className="h-1">GET THE APP</p>
        <p className="h-2 hide-on-large">
          Our users say that
          <br /> All Roadside Assistance
          <br /> is easier to use than other service apps.
        </p>
        <p className="h-2 hide-on-small">
          Our users say that All Roadside Assistance
          <br /> is easier to use than other service apps.
        </p>
        {/* <br /> */}
        <p className="h-2 its-free">And it's FREE!</p>
        {/* <br /> */}
        <p className="h-2">Don't Believe Them? Try it Yourself</p>
        <p className="h-3 hide-on-small">
          You will receive a one time SMS to download the
          <br /> free app.
        </p>
        <p className="h-3 hide-on-large">
          You will receive a one time SMS to download the free app.
        </p>
      </div>
      <form
        className="buttons"
        onSubmit={(e) => {
          if (!request.loading) {
            onSubmit(e);
          }
        }}
      >
        <input
          type="number"
          name="phone"
          placeholder="(123) 123-4567"
          onChange={(e) => onChange(e)}
        />
        <p>
          {request.success === true
            ? 'Message Sent'
            : request.success === false
            ? 'Invalid Recipient'
            : null}
        </p>
        <input
          type="submit"
          className={request.loading && 'loading'}
          // className="loading"
          value={request.loading ? 'loading...' : 'Text App Link'}
        />
      </form>
      <div className="links">
        <a href="https://apps.apple.com/us/app/all-roadside-assistance/id1456544810">
          {/* <img src="https://img.icons8.com/wired/32/000000/mac-os.png" /> */}
          <img src={Apple} alt="..." />
          <span>
            <span className="small-text">Download on the</span>
            <br />
            <span className="bold-text">App Store</span>
          </span>
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.allroadsideassistance.allroadsideassistance&hl=en_US">
          <img
            src="https://img.icons8.com/color/32/000000/google-play.png"
            alt="..."
          />
          <span>
            <span className="small-text">GET IT ON</span>
            <br />
            <span className="bold-text">Google Play</span>
          </span>
        </a>
      </div>
    </div>
  );
};

export default Home;
